import { Intercom } from 'react-live-chat-loader'

const IntercomChat = ({ color }) => <Intercom color={color} />

export default IntercomChat
